import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const rapidboardUserBacklogRoute: InvariantJiraRoute = {
	name: 'rapidboard-user-backlog',
	path: '/jira/people/:accountId/boards/:boardId/backlog',
};
